<template>
  <div class="depara-revisao">
    <el-table
      class="p-table"
      v-loading="tableLoading"
      :data="tableOptions.data"
      style="width: 100%"
      stripe
      border
      :summary-method="getSummaries"
      show-summary
      @selection-change="selectRevisao"
      size="mini">

        <el-table-column
          type="selection"
          width="55"
          align="center">
        </el-table-column>
      
        <el-table-column
        label="Plano de Contas"
        align="center">

          <el-table-column
          prop="valorPrimeiraColuna"
          sortable
          align="left">
          <template slot="header">
            <span>Franqueado</span>
            <el-popover ref="filterNomeRevisao" placement="bottom" trigger="click" width="400" @click.native.stop>
                <div style="margin-bottom:5px">
                  <b-form-input size="sm" v-model="model.nome" placeholder="Pesquisar nome"></b-form-input>
                  <!-- <el-input placeholder="Pesquisar nome" v-model="model.nome" size="mini"></el-input> -->
                </div>
                <el-button style="float:right" type="primary" size="mini" icon="el-icon-search" @click="setFilter">Filtrar</el-button>
                <el-button style="float:right; margin-right: 5px;" size="mini" icon="el-icon-brush" @click="clearFilter('nome')">Limpar</el-button>
                <el-button style="float:right" slot="reference" icon="fas fa-filter" size="mini" circle></el-button>
            </el-popover>
          </template>
          <template slot-scope="scope" v-if="scope.row">
            <template v-if="scope.row.valorPrimeiraColuna">
              {{ scope.row.valorPrimeiraColuna.label }}
              <ModalHistorico :visible="scope.row.temHistorico" :options="scope.row.historico"></ModalHistorico>
            </template>
          </template>
          </el-table-column>
          <el-table-column
          prop="valorSegundaColuna"
          sortable
          label="Franqueador"
          align="left">
          <template slot-scope="scope" v-if="scope.row">
            <template v-if="scope.row.valorSegundaColuna">
              {{ scope.row.valorSegundaColuna.label }}
            </template>
          </template>
          </el-table-column>
          
        </el-table-column>

        <el-table-column
          prop="tipo"
          label="Tipo"
          align="center"
          :filters="tipoNomes"
          :filter-method="filterTipo"
          width="200">

          <template slot-scope="scope" v-if="scope.row">
            <el-tag size="small" type="primary" effect="plain">{{ scope.row.tipo }}    </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="marca"
          label="Marcas"
          align="center"
          :filters="marcaNomes"
          :filter-method="filterMarca"
          width="200">

          <template slot-scope="scope" v-if="scope.row">
            <el-tag size="small" type="primary" effect="plain">{{ scope.row.marca }}    </el-tag>
          </template>
        </el-table-column>
        
      </el-table><br>
      <el-pagination
        class="text-center"
        background
        layout="sizes, prev, pager, next"
        @size-change="paginacaoSize"
        @current-change="paginacaoCurrent"
        :page-size="tableOptions.paginacao.pageSize"
        :current-page.sync="tableOptions.paginacao.page"
        :total="tableOptions.paginacao.total"
        :page-sizes="[5, 10, 25, 50, 75, 100]">
      </el-pagination>

      <DisaproveButton
        :loading="loadingBtns"
        v-show="!enableBtn"
        @click="desaprovar"
        style="right: 170px;"
      />

      <AproveButton
        :loading="loadingBtns"
        v-show="!enableBtn"
        @click="aprovar"
      />
  </div>
</template>
<script>
  import ModalHistorico from '@/views/DePara/ModalHistorico.vue';
  import DisaproveButton from '../widget/DisaproveButton.vue';
  import AproveButton from '../widget/AproveButton.vue';
  
const viewModel = (val) => {
      return {
        deParaId: val.deParaId || [],
        marca: val.marca || null,
        valorPrimeiraColuna: val.valorPrimeiraColuna || '',
        valorSegundaColuna: val.valorSegundaColuna || [],
        temHistorico: val.temHistorico || false,
        historico: val.historico || []
      }
  }

  export default {
    props: ['tab'],
    data(){
      return {
        model: {
            nome: ''
        },
        tempModel: [],
        tableHeight: window.innerHeight - 310,
        loadingBtns: false,
        tableOptions: {
          load: false,
          data: [],
          paginacao: {
            page: 1,
            pageSize: 10,
            total: 10
          }
        }
      }
    },
    components: {
      ModalHistorico,
      AproveButton,
      DisaproveButton
    },
    methods: {
      // request
      async getRevisoes() {
        try {
          this.tableOptions.load = true;
          const response = await this.axios.get(this.$urls.DE_PARA_REVISAO, {
            params: {
              page: this.tableOptions.paginacao.page,
              pageSize: this.tableOptions.paginacao.pageSize,
              //Order: '', // verificar como vai ser a ordenação
              CustomerId: this.$route.params.customerId,
              Marcas: this.$route.query.marcas,
              Visao: 'Franqueado', // Franqueado ou franqueador
              Nome: this.model.nome
            }
          });

          this.tableOptions.load = false
          
          if(response.status !== 200){
            this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
            return;
          }
          
          this.tableOptions.data = response.data.valores;
          this.tableOptions.paginacao.page = response.data.page;
          this.tableOptions.paginacao.total = response.data.total;
          
        } catch(err) {
          this.$notify.error({
            title: 'Erro interno',
            message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
            position:'top-left'
          });
        } finally {
          this.tableOptions.load = false
        }
      },
      async postAprovarDesaprovar(isAprovar) {
        this.loadingBtns = true;
        try {
          const dataEnvio = this.tempModel.map(item => item.deParaId)

          const dataInfo = {
            request: isAprovar ? this.$urls.DE_PARA_APROVAR : this.$urls.DE_PARA_DESFAZER,
            message: isAprovar ? "De-para aprovado com sucesso" : "De-para desaprovado com sucesso"
          }
 
          const response = await this.axios.post(dataInfo.request, dataEnvio);
          
          if(response.status !== 200){
            this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
            return;
          }
          
          this.$message.success(dataInfo.message);
          this.getRevisoes();
          
        } catch(err) {
          this.$notify.error({
            title: 'Erro interno',
            message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
            position:'top-left'
          });
        } finally {
          this.loadingBtns = false
        }
      },
      
      // paginacao
      paginacaoCurrent(val){
        this.tempModel = []
        this.tableOptions.paginacao.page = val
        this.getRevisoes()
      },
      paginacaoSize(val){
          this.tempModel = []
          this.tableOptions.paginacao.pageSize = val
          this.tableOptions.paginacao.page = 1
          this.getRevisoes()
      },
      // methods
      selectRevisao(rows) {
        this.tempModel = []
        rows.forEach((item) => {
          this.tempModel.push(viewModel(item));
        })

        console.log(this.tempModel);
      },
      aprovar() {
        this.$confirm('Tem certeza que deseja aprovar todos os de-paras selecionados?', 'Aprovar De-Para', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          type: 'success'
        }).then(() => {
          this.postAprovarDesaprovar(true)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Aprovação cancelada'
          });       
        });
      },
      desaprovar() {
        this.$confirm('Tem certeza que deseja desaprovar todos os de-paras selecionados?', 'Reprovar De-Para', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          type: 'error'
        }).then(() => {
          this.postAprovarDesaprovar()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Desaprovação cancelada'
          });      
        });
      },
      getSummaries() {
        const sums = [];

        sums[1] = 'Total Revisão';
        sums[2] = this.tableOptions.paginacao.total;

        return sums;
      },
      filterMarca(value, row) {
        return row.marca === value;
      },
      filterTipo(value, row) {
        return row.tipo === value;
      },
      setFilter() {
          this.tableOptions.paginacao.page = 1
          this.getRevisoes();
      },
      clearFilter(name) {
            this.model[name] = ''
            this.getRevisoes();
      }
    },  
    computed: {
      enableBtn() {
        return this.tempModel.length ? false : true
      },
      marcaNomes() {
        const unique = [...new Set(this.tableOptions.data.map((item) => item.marca))]
        const formatArray = unique.map(item => {
          return { text: item, value: item }
        })
        return formatArray
      },
      tipoNomes() {
        const unique = [...new Set(this.tableOptions.data.map((item) => item.tipo))]
        const formatArray = unique.map(item => {
          return { text: item, value: item }
        })
        return formatArray
      },
      tableLoading() {
        return this.tableOptions.load || this.loadingBtns
      }
    },
    mounted() {
      this.getRevisoes()
    },
    created() {
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.tableHeight = window.innerHeight - 390
        });
      })
    }
  }
</script>
<style lang="scss" scoped>
.switch-plano {
  float: right;
}
.actions-depara {
    position: relative;
    padding: 11px 5px 5px;
    display: block;
    background: #FFF;
    width: 100%;
    height: 44px;
    margin-top: 15px;
    border-top: 1px solid #e3e3e3;
}
.btn-depara {
  width:105px;
}
</style>
